import * as React from 'react';
import { type VariantProps, cva } from 'class-variance-authority';
import { Tooltip as TooltipPrimitive } from 'radix-ui';

import { cn } from '~/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const tooltipVariants = cva(
  'z-50 overflow-hidden rounded-lg border animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
  {
    variants: {
      variant: {
        default:
          'max-w-xs border-gray-200 bg-white px-3 py-1.5 text-xs leading-4 text-gray-900 shadow-lg',
        form: 'wrap-break-word border-gray-200 bg-white px-3 py-2 text-center text-xs leading-4 font-light text-gray-500 shadow-lg',
        dark: 'max-w-xs border-gray-700 bg-gray-800 px-3 py-1.5 text-xs leading-4 text-white shadow-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

interface TooltipContentProps
  extends
    React.ComponentProps<typeof TooltipPrimitive.Content>,
    VariantProps<typeof tooltipVariants> {}

function TooltipContent({
  className,
  variant,
  sideOffset = 4,
  ref,
  ...props
}: TooltipContentProps) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(tooltipVariants({ variant }), className)}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
